
import ROUTERS from '../../commons/constans/router';
import React, { lazy } from 'react';

const AlbumComponent = lazy(() => import('../../pages/Album/containers/AlbumPageContainer'));
const AlbumDetailComponent = lazy(() => import('../../pages/Album/containers/AlbumDetailPageContainer'));

const route = [
  {
    path: ROUTERS.ALBUM,
    title: 'Album',
    exact: true,
    public: false,
    component: <AlbumComponent />
  },
  {
    path: ROUTERS.ALBUM_DETAIL,
    title: 'Album detail',
    exact: true,
    public: false,
    component: <AlbumDetailComponent />
  },
];

export default route;